import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Icon, Button } from '@tcc/crate';
import styles from '../cards/cardAndPreview/cardAndPreview.css';

interface CollapseProps {
  children: React.ReactNode[];
  collapseText: string;
  expandText: string;
  testId?: string;
}

export const Collapse = ({ children, collapseText, expandText, testId = 'collapse-expand' }: CollapseProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const currentChildren = useRef(children);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    setIsCollapsed(true);
    currentChildren.current = children;
  }, [children]);

  return (
    <>
      {currentChildren.current[0]}
      {!isCollapsed && currentChildren.current.slice(1)}
      {currentChildren.current.length > 1 && (
        <Button
          className={styles.collapseBtn}
          mode="link"
          onClick={toggleCollapse}
          testId={testId}
        >
          <span>
            {isCollapsed ? (
              <Icon glyph={Icon.set.ARROW_DOWN} />
            ) : (
              <Icon glyph={Icon.set.ARROW_UP} />
            )}
          </span>
          <span>{isCollapsed ? expandText : collapseText}</span>
        </Button>
      )}
    </>
  );
}
